import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { NativeInteractiveContainerElement1pn7ly9a3ij8y as NativeInteractiveContainerElement } from '../InteractiveElement.commonHtml.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../NativeElement.commonHtml.js.mjs';
import { ClickableSemantic_getInstance29tidgppnw5x2 as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  toggleDriverValue7dymtxaciltl as toggleDriverValue,
  toggleDriverActions4ap7fpkrm5vy as toggleDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ToggleButton$lambda(it) {
  if (!(it instanceof KeyboardEvent))
    THROW_CCE();
  if (it.code === KeyCodes_instance.get_space_iyncv1_k$() || it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
    it.preventDefault();
  }
  return Unit_instance;
}
function ToggleButton$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.attributes_1.native_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function ToggleButton$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.attributes_1.native_1.checked = value;
  return Unit_instance;
}
var ToggleButtonClass;
function ToggleButton() {
  if (ToggleButtonClass === VOID) {
    class $ extends NativeInteractiveContainerElement() {
      constructor(context) {
        super(context);
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (FutureElement())();
        this.set_themeChoice_py59um_k$(this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ClickableSemantic_getInstance()));
        this_0.tag_1 = 'input';
        var tmp0 = this_0.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'checkbox';
        tmp0.native_1.type = value;
        this_0.classes_1.add_utx5q5_k$('checkResponsive');
        this_0.classes_1.add_utx5q5_k$('kui');
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        this_0.attributes_1.native_1.hidden = true;
        // Inline function 'com.lightningkite.kiteui.views.display' call
        this_0.style_1.native_1.display = 'none';
        tmp.input_1 = this_0;
        this.native_1.tag_1 = 'label';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.native_1.classes_1.add_utx5q5_k$('checkResponsive');
        this.native_1.classes_1.add_utx5q5_k$('clickable');
        // Inline function 'com.lightningkite.kiteui.views.tabIndex' call
        this.native_1.attributes_1.native_1.tabIndex = 0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_1 = this.native_1;
        var tmp0_safe_receiver = this_1.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', ToggleButton$lambda);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_1.eventsBack_1['on' + 'keydown'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keydown';
          this_1.eventsBack_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_space_iyncv1_k$() || it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_2 = this.native_1;
        var tmp0_safe_receiver_0 = this_2.element_1;
        var tmp_3;
        if (tmp0_safe_receiver_0 == null) {
          tmp_3 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_space_iyncv1_k$() || it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              this.input_1.click_jclltk_k$();
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          // Inline function 'kotlin.run' call
          var tmp_4 = this_2.eventsBack_1['on' + 'keyup'];
          var old_0 = (!(tmp_4 == null) ? typeof tmp_4 === 'function' : false) ? tmp_4 : null;
          var tmp_5 = 'on' + 'keyup';
          this_2.eventsBack_1[tmp_5] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_space_iyncv1_k$() || it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              this.input_1.click_jclltk_k$();
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        this.native_1.appendChild_gtildm_k$(this.input_1);
        var tmp_6 = this;
        var tmp_7 = ToggleButton$checked$lambda;
        tmp_6.checked_1 = vprop(this.input_1, 'input', tmp_7, ToggleButton$checked$lambda_0);
        this.native_1.setAttribute_j9pxft_k$('role', 'button');
        this.native_1.setAttribute_j9pxft_k$('aria-pressed', 'false');
        // Inline function 'kotlin.also' call
        var this_3 = this.checked_1.addListener_6y9mct_k$(() => {
          var tmp;
          if (this.checked_1.get_value_j01efc_k$()) {
            this.native_1.classes_1.add_utx5q5_k$('checked');
            this.native_1.setAttribute_j9pxft_k$('aria-pressed', 'true');
            tmp = Unit_instance;
          } else {
            this.native_1.classes_1.remove_cedx0m_k$('checked');
            this.native_1.setAttribute_j9pxft_k$('aria-pressed', 'false');
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        onRemove(this, this_3);
      }
      get_driverValue_yh5neo_k$() {
        return toggleDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), toggleDriverActions(this));
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
    }
    initMetadataForClass($, 'ToggleButton');
    ToggleButtonClass = $;
  }
  return ToggleButtonClass;
}
//region block: exports
export {
  ToggleButton as ToggleButton22qnd3p3jsqqx,
};
//endregion

//# sourceMappingURL=ToggleButton.commonHtml.mjs.map
